import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import "core-js/modules/es6.function.name";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _extends from "@babel/runtime-corejs2/helpers/extends";

var _dec, _class, _class2, _temp;

/* eslint-disable react/jsx-no-bind */
import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@rexlabs/styling';
import withA11y from './behaviour/with-a11y';
import withHint from './behaviour/with-hint';
import defaultStyles from './styles';
import _ from 'lodash';
export var CHECKBOX = 'checkbox';
export var RADIO = 'radio';

function prepend(value, array) {
  var newArray = array.slice();
  newArray.unshift(value);
  return newArray;
}

function CheckboxLabel(props) {
  var styles = props.styles,
      children = props.children,
      label = props.label,
      id = props.id;
  return React.createElement("label", _extends({}, styles('label'), {
    htmlFor: id
  }), Children.toArray(children).length > 0 ? prepend(label, Children.toArray(children)) : label);
}

var Checkbox = (_dec = styled(defaultStyles), withA11y(_class = withHint(_class = _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          label = _this$props.label,
          labelPosition = _this$props.labelPosition,
          disabled = _this$props.disabled,
          setRef = _this$props.setRef,
          Container = _this$props.Container,
          containerProps = _this$props.containerProps,
          prefix = _this$props.prefix,
          suffix = _this$props.suffix,
          onChange = _this$props.onChange,
          styles = _this$props.styles,
          checkIcon = _this$props.checkIcon,
          children = _this$props.children,
          meta = _this$props.meta,
          tabIndex = _this$props.tabIndex,
          inputProps = _objectWithoutProperties(_this$props, ["type", "id", "name", "value", "label", "labelPosition", "disabled", "setRef", "Container", "containerProps", "prefix", "suffix", "onChange", "styles", "checkIcon", "children", "meta", "tabIndex"]);

      return React.createElement(Container, _extends({}, containerProps, styles({
        container: true,
        disabled: disabled
      }), !_.isString(Container) && {
        styles: styles
      }), labelPosition === 'left' ? React.createElement(CheckboxLabel, this.props) : null, React.createElement("span", styles('prefix'), prefix), React.createElement("input", _extends({}, inputProps, styles('input'), {
        type: type,
        id: id,
        name: name,
        disabled: disabled,
        ref: setRef,
        checked: value,
        onChange: onChange,
        tabIndex: "-1"
      })), React.createElement("label", {
        htmlFor: id,
        tabIndex: tabIndex || '0',
        onKeyDown: function onKeyDown(_ref) {
          var key = _ref.key,
              e = _objectWithoutProperties(_ref, ["key"]);

          if (key === 'Enter') onChange(_objectSpread({
            key: key
          }, e));
        }
      }, checkIcon && checkIcon), labelPosition === 'right' ? React.createElement(CheckboxLabel, this.props) : null, React.createElement("span", styles('suffix'), suffix));
    }
  }]);

  return Checkbox;
}(Component), _defineProperty(_class2, "displayName", 'Checkbox'), _defineProperty(_class2, "defaultProps", {
  type: CHECKBOX,
  labelPosition: 'right',
  disabled: false,
  setRef: _.noop,
  Container: 'span',
  containerProps: {},
  prefix: undefined,
  suffix: undefined
}), _temp)) || _class) || _class) || _class);
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.oneOf([CHECKBOX, RADIO]),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node, PropTypes.element]),
  labelPosition: PropTypes.string,
  disabled: PropTypes.bool,
  setRef: PropTypes.func,
  Container: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  containerProps: PropTypes.object,
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  checkIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func.isRequired
} : {};
Checkbox.displayName = 'Checkbox';
export default Checkbox;